import React from 'react';
import { Check } from 'lucide-react';

const steps = [
  { key: 'applicant', n: 1, label: 'Applicant' },
  { key: 'options', n: 2, label: 'Options' },
  { key: 'send', n: 3, label: 'Send' },
];

export default function VerificationStepIndicator({ current = 'applicant', completed = [] }) {
  const completedSet = new Set(completed);
  return (
    <div className="w-full max-w-2xl" data-testid="verification-step-indicator">
      <div className="flex items-center">
        {steps.map((step, index) => {
          const isActive = current === step.key;
          const isCompleted = completedSet.has(step.key);
          return (
            <React.Fragment key={step.key}>
              <div className="flex items-center gap-2 min-w-0">
                <span className={`w-7 h-7 shrink-0 grid place-items-center border rounded-sm text-xs font-mono ${
                  isActive
                    ? 'bg-zinc-900 border-zinc-900 text-white'
                    : isCompleted
                      ? 'bg-zinc-50 border-zinc-300 text-zinc-700'
                      : 'bg-white border-zinc-200 text-zinc-400'
                }`}>
                  {isCompleted ? <Check className="w-3.5 h-3.5" strokeWidth={1.8}/> : step.n}
                </span>
                <span className={`text-xs font-mono uppercase tracking-widest truncate ${
                  isActive ? 'text-zinc-900' : isCompleted ? 'text-zinc-600' : 'text-zinc-400'
                }`}>
                  {step.label}
                </span>
              </div>
              {index < steps.length - 1 && (
                <div className={`h-px flex-1 mx-3 ${isCompleted ? 'bg-zinc-300' : 'bg-zinc-200'}`}/>
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}
